<template>
  <section class="ElementsSidebar">
    <hooper ref="elementsSlider">
      <template v-if="itemsPerRow > 1">
        <hooper-slide v-for="group, index in itemsGroups" :key="index">
          <div class="ElementsSidebar__group">
            <div class="ElementsSidebar__element" :class="{'ElementsSidebar__element--big' : itemsPerRow <= 4}"
              v-for="element in group"
              :key="element.id">
              <img
                class="ElementsSidebar__image"
                :src="require(`@/assets/img/elements/${element.id}.${element.ext}`)"
                @click="onElementClick"
                draggable="true"
                @dragstart="onDragStart"
              />
            </div>
          </div>
        </hooper-slide>
      </template>
      <template v-else>
        <hooper-slide v-for="element in itemsGroups" :key="element.id">
          <img
            class="ElementsSidebar__element"
            :src="require(`@/assets/img/elements/${element.id}.${element.ext}`)"
            @click="onElementClick"
            draggable="true"
            @dragstart="onDragStart"
          />
        </hooper-slide>
      </template>
      <hooper-navigation slot="hooper-addons"></hooper-navigation>
    </hooper>
  </section>
</template>

<script>
import {loadToolElements} from "@/utils";
import { Hooper, Slide as HooperSlide, Navigation as HooperNavigation } from 'hooper';
import 'hooper/dist/hooper.css';

export default {
  name: "ElementsSidebar",
  components: {
    Hooper,
    HooperSlide,
    HooperNavigation
  },
  props: {
    itemsPerRow: {
      default: null,
      type: Number
    },
    filterByType: {
      default: null,
      type: String
    }
  },
  data() {
    return {
      elements: loadToolElements(),
      start: false,
    };
  },
  watch: {
    filterByType: function() {
      this.$refs['elementsSlider'].slideTo(0);
    }
  },
  computed: {
    filterItems() {
      return this.elements;
    },
    itemsGroups () {
      return this.itemsPerRow && this.itemsPerRow > 1 ? this.sliceIntoChunks(this.filterItems, this.itemsPerRow) : this.filterItems;
    }
  },
  methods: {
    onDragStart(event) {
      console.log(event);
    },
    onElementClick(event) {
      this.$emit("elementClick", event);
    },
    sliceIntoChunks(arr, chunkSize) {
      const res = [];
      for (let i = 0; i < arr.length; i += chunkSize) {
          const chunk = arr.slice(i, i + chunkSize);
          res.push(chunk);
      }
      return res;
    }
  },
  mounted() {
    this.start = true;
  }
};
</script>

<style lang="scss" scoped>
.ElementsSidebar {
  $elementsClass: &;
  width: 25vw;
  margin: -1.5vw -1.09vw 0 0;


  &__group {
    width: 20vw;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin: 0 auto;
    justify-content: space-evenly;
    #{$elementsClass}__element {
      cursor: pointer;
      width: 33%;
      height: 50%;
      &--big {
        width: 24%;
        height: 100%;
        #{$elementsClass}__image {
          width: 100%;
          height: 5vw;
        }
      }
    }
    #{$elementsClass}__image {
      width: 3.745vw;
      height: 3.745vw;
    }
  }
  &__element {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>

<style lang="scss">
.hooper {
  margin-bottom: 1.94vh;
  height: auto;
  &-navigation {
    margin-top: 2vw;
  }
  &-prev, &-next {
    svg {
      display: none;
    }
    &:before {
      content: '';
      display: block;
      width: 1.25vw;
      height: 1.25vw;
      background: transparent url('~~@/assets/img/ui/btn_freccia_sx.svg') no-repeat center center;
      transform: rotate(-90deg);
    }
  }
  &-next {
    &:before {
      transform: rotate(90deg);
    }
  }
}
</style>